import { BitkitIconComponent, BitkitTag, IconAndroid, IconApple } from '@bitrise/bitkit-v2';
import { Box, BoxProps } from '@chakra-ui/react/box';
import { Fragment } from 'react';

import ArtifactTypeFilter from '@/models/ArtifactTypeFilter';
import { InstallableArtifact } from '@/models/Build';

export interface InstallableArtifactsProps extends BoxProps {
  artifacts?: InstallableArtifact[];
}

const Item = (props: { icon: BitkitIconComponent; labelText: string }) => {
  const { icon, labelText } = props;
  return <BitkitTag cursor="text" icon={icon} labelText={labelText} size="sm" />;
};

const getGroupedAndroidLabel = (items: InstallableArtifact[]) => {
  let lastExtensionType = '';
  let hasBothType = false;

  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    const extension = (item.title?.split('.').pop() || '').toLowerCase();
    if (lastExtensionType !== '' && extension !== lastExtensionType) {
      hasBothType = true;
      break;
    }
    lastExtensionType = extension;
  }

  return hasBothType ? 'APK/AAB' : lastExtensionType?.toUpperCase() || 'APK';
};

const InstallableArtifacts = (props: InstallableArtifactsProps) => {
  const { artifacts, ...rest } = props;

  if (!artifacts || artifacts.length === 0) {
    return null;
  }

  const separatedByType: Record<ArtifactTypeFilter, InstallableArtifact[]> = {
    [ArtifactTypeFilter.APK]: [],
    [ArtifactTypeFilter.IPA]: [],
  };
  artifacts.forEach((artifact) => {
    separatedByType[artifact.artifactType].push(artifact);
  });

  return (
    <Box display="flex" gap="8" zIndex="1" {...rest}>
      {(Object.keys(separatedByType) as (keyof typeof separatedByType)[]).map((type) => {
        const items = separatedByType[type];
        let icon: BitkitIconComponent = IconApple;
        let groupedAndroidLabel = 'APK';

        if (type === ArtifactTypeFilter.APK) {
          icon = IconAndroid;
          groupedAndroidLabel = getGroupedAndroidLabel(items);
        }

        if (items.length === 0) {
          return null;
        }

        if (items.length < 3) {
          return (
            <Fragment key={type}>
              {items.map(({ id, versionCode, versionName }) => {
                if (!versionName) {
                  return null;
                }
                return (
                  <Item icon={icon} key={id} labelText={`v${versionName}${versionCode ? ` (${versionCode})` : ''}`} />
                );
              })}
            </Fragment>
          );
        }
        return (
          <Item
            icon={icon}
            key={type}
            labelText={`${type === ArtifactTypeFilter.APK ? groupedAndroidLabel : 'IPA'} (${items.length})`}
          />
        );
      })}
    </Box>
  );
};

export default InstallableArtifacts;
